import { defineComponent as _defineComponent } from 'vue'
import { JobJson } from '@/models/types/job-json'
import { useRouter } from 'vue-router/composables'


export default /*#__PURE__*/_defineComponent({
  __name: 'Batch',
  props: {
    value: null,
    job: null
  },
  setup(__props: any) {

const props = __props as {
  value?: string | null
  job: JobJson
}



const router = useRouter()

function handleClick() {
  router.push({
    name: 'job-search-batches-info-panel',
    params: {
      batchId: props.job.invoice_id ?? '',
    },
  })
}

return { __sfc: true,props, router, handleClick }
}

})